import { render } from "./AppFrame.vue?vue&type=template&id=d64bbcd4"
const script = {}

import exportComponent from "C:\\Projects\\osago\\landing-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__